import { render } from "./UserModeration.vue?vue&type=template&id=acd97e6c"
import script from "./UserModeration.vue?vue&type=script&lang=js"
export * from "./UserModeration.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__